// src/Pages/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import '../stylesheets/Components.css'

const NotFound = () => {
  return (
    <div className='NotFound'>
      <h1>404 - Page Not Found</h1>
      <p>Sorry, the page you are looking for does not exist.</p>
      <Link to='./' className='returnhome'>Return Home</Link>
    </div>
  );
};

export default NotFound;
